/**
 * R7.2.2F4 / F4A — single Customer camera trigger (canonical SVG only).
 * Home / Search / PDP arm path + VisualSearchPanel closed trigger share CameraTriggerIcon.
 */
import type { KeyboardEvent, MouseEvent, PointerEvent } from "react";
import { CameraTriggerIcon } from "@asiastyle/surface-ui/visual-search";

export type CustomerCameraTriggerState = "idle" | "loading" | "acquiring";

type Props = {
  lang: "uk" | "en";
  state?: CustomerCameraTriggerState;
  disabled?: boolean;
  testId?: string;
  className?: string;
  onPointerUp?: (e: PointerEvent<HTMLButtonElement>) => void;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
};

export function CustomerCameraTrigger({
  lang,
  state = "idle",
  disabled,
  testId = "sv2-visual-search-arm",
  className = "sv2-visual-search-trigger",
  onPointerUp,
  onClick,
  onKeyDown,
}: Props) {
  const busy = state === "loading" || state === "acquiring";
  const label = lang === "en" ? "Search by photo or barcode" : "Пошук за фото або штрихкодом";
  return (
    <button
      type="button"
      className={`as-camera-trigger ${className}${busy ? " sv2-visual-search-trigger-loading" : ""}`}
      aria-label={label}
      aria-busy={busy || undefined}
      aria-haspopup="dialog"
      disabled={disabled}
      data-testid={testId}
      data-camera-trigger="canonical-svg"
      data-camera-state={state}
      data-home-camera-fixture={testId === "sv2-visual-search-arm" ? "true" : undefined}
      onPointerUp={onPointerUp}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <span className="sv2-visual-search-trigger-icon" aria-hidden="true">
        <CameraTriggerIcon size={20} />
      </span>
      {busy ? <span className="sv2-visual-search-trigger-spinner" aria-hidden="true" /> : null}
    </button>
  );
}
